/**
 * Sanitizes a CSV string by prefixing every value with a non-printable character.
 */
export const sanitizeCsvFields = (csvString: string): string => {
  if (!csvString) {
    return '';
  }

  const NON_PRINTABLE_CHARACTER = '\b';
  const rows = csvString.split('\n');
  const sanitizedRows = rows.map((row) => {
    const values = row.split(',');
    const sanitizedValues = values.map((value) => {
      const preformattedValue = value.replace(/\"/g, '');

      return `${NON_PRINTABLE_CHARACTER}${preformattedValue}`;
    });

    return sanitizedValues.join(',');
  });

  return sanitizedRows.join('\n');
};



// WEBPACK FOOTER //
// ./src/app/utils/csv.js